import { Component, OnInit, Input, ElementRef, HostListener, OnChanges, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-product-prices-card',
  templateUrl: './catalogs-product-prices-card.component.html',
  styleUrls: ['./catalogs-product-prices-card.component.scss']
})
export class CatalogsProductPricesCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() product;
  @Input() magnitudes;
  editingLocked;
  productPricesForm = new FormGroup({
    quantity: new FormControl({ value: null, disabled: true }),
    magnitude: new FormControl({ value: null, disabled: true }),
    price: new FormControl({ value: null, disabled: true }),
    offerPrice: new FormControl({ value: null, disabled: true }),
    tax: new FormControl({ value: null, disabled: true }),
  });
  updateProductPricesSubscription: Subscription;

  constructor(private productsService: ProductsService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.product) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.product && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
        this.lockEdition();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateProductPricesSubscription = this.productsService.updateProductPrices(this.product.InternalId, this.productPricesForm).subscribe(
        (res) => {
          this.editingLocked = true;
          this.snackbarService.open('catalogs-page.snackbar messages.update product success', 'success');
          this.productsService.refreshProduct();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.productsService.refreshProduct();
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    return true;
  }

  public resetForm() {
    this.productPricesForm.patchValue({
      quantity: this.product.Measure,
      magnitude: this.product.MeasureUnit,
      price: this.product.PricePVP,
      offerPrice: this.product.PricePVPOffer,
      tax: this.product.TaxAmount
    });
  }

  public unlockEdition() {
    this.productPricesForm.get('quantity').enable();
    this.productPricesForm.get('magnitude').enable();
    this.productPricesForm.get('price').enable();
    this.productPricesForm.get('offerPrice').enable();
    this.productPricesForm.get('tax').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.productPricesForm.get('quantity').disable();
    this.productPricesForm.get('magnitude').disable();
    this.productPricesForm.get('price').disable();
    this.productPricesForm.get('offerPrice').disable();
    this.productPricesForm.get('tax').disable();
    this.editingLocked = true;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  ngOnDestroy() {
    if (this.updateProductPricesSubscription) { this.updateProductPricesSubscription.unsubscribe(); }
  }

}
